import {Injectable} from '@angular/core';
import {DateHelperService, UrlProviderService} from "../../../../shared/services/general";
import {HttpClient} from "@angular/common/http";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../stores/app.state";
import {FusionAuthService} from "../../../../shared/services/fusion-auth";
import {Router} from "@angular/router";
import CustomStore from "devextreme/data/custom_store";
import * as Moment from "moment";
import {HttpRequestBuilder, ObjectUtils, SECURED_STORE} from "../../../../shared/utils";
import {ResultEntrySearchFilter} from "../models/SearchFilter";
import DevExpress from "devextreme";
import DataSource = DevExpress.data.DataSource;
import {BehaviorSubject} from "rxjs";
import {xor} from 'lodash';
import {NormalTestRun} from "../models/test-run";
import {retry} from "rxjs/operators";

@Injectable()
export class OrderService {
  constructor(
    private urlProvider: UrlProviderService,
    private httpClient: HttpClient,
    private store: Store<AppState>,
    private fusionAuthService: FusionAuthService,
    private router: Router
  ) {
  }

  public searchStore(params: ResultEntrySearchFilter, dataSource: BehaviorSubject<DataSource | null>): CustomStore {
    const ds = dataSource as BehaviorSubject<DataSource>;
    for (const paramsKey in params) {
      if (Array.isArray(ObjectUtils.getKeyValue(params, paramsKey)) && (ObjectUtils.getKeyValue(params, paramsKey) as any[]).length === 0) {
        // @ts-ignore
        delete params[paramsKey];
      }
    }

    if (params.clients === undefined || params.clients === null) params.clients = [];

    /*if (this.fusionAuthService.Profile?.registrations[0]?.roles[0]?.includes("Client")) {
      const clients = xor(params.clients, this.fusionAuthService.Profile.data.clients);
      params.clients.push(...clients);
    }*/

    if (params.start) {
      params.start = Moment(params.start).format('MM/DD/YYYY');
    }

    if (params.end) {
      params.end = Moment(params.end).format('MM/DD/YYYY');
    }

    return SECURED_STORE({
      dataSource: ds,
      loadParams: params,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      routerService: this.router,
      loadUrl: `${this.urlProvider.ApiUrl}/v2/result-entry/orders-search`,
    });
  }

  public getOrdersConfigurations({
    clientsIds,
                                   orderIds,
                                   testIds,
                                   showOnlyPending
                                 }: { orderIds: number[], testIds: number[], clientsIds: number[], showOnlyPending: boolean }) {
    const httpRequestBuilder = new HttpRequestBuilder(this.httpClient)
      .setUrl(`${this.urlProvider.ApiUrl}/v2/result-entry/orders-configuration`);
    httpRequestBuilder.getOptions().reportProgress = true;
    httpRequestBuilder.setMethod('POST')
    httpRequestBuilder.setUrlParameter('showOnlyPending', showOnlyPending)
    httpRequestBuilder.setJsonBody({
      clientsIds,
      ordersIds: orderIds,
      testsIds: testIds
    })
    return httpRequestBuilder.build().pipe(retry(2));
  }

  public saveResults(results: NormalTestRun[]) {
    const httpRequestBuilder = new HttpRequestBuilder(this.httpClient)
      .setUrl(`${this.urlProvider.ApiUrl}/v2/result-entry/save-results`);
    httpRequestBuilder.getOptions().reportProgress = true;
    httpRequestBuilder.setMethod('POST');
    httpRequestBuilder.setJsonBody({
      results
    })
    return httpRequestBuilder.build();
  }
}
